import React, { useState } from "react";
import AppChip from "../../../shared/components/ui/AppChip";
import ServiceFilterAccordion from "../../../shared/components/home/ServiceFilterAccordion";
import {
  DEFAULT_EXPANDED_SERVICE_SECTIONS,
  SERVICE_FOR_OPTIONS,
  SERVICE_SECTIONS,
} from "../../../shared/data/profileFilterOptions";
import { useOnboarding } from "../OnboardingContext";
import OnboardingWizard from "../OnboardingWizard";
import { toggleListItem } from "../onboardingDraft";
import { useEditStepSave } from "../useEditStepSave";

export default function StepServices() {
  const { draft, updateDraft, goToNextStep, goToPrevStep, isEditMode } = useOnboarding();
  const [expandedSections, setExpandedSections] = useState(
    () => ({ ...DEFAULT_EXPANDED_SERVICE_SECTIONS }),
  );

  const canContinue = draft.serviceFor.length > 0 && draft.services.length > 0;
  const { showSave, onSave, saveDisabled, saveLabel, saveError } = useEditStepSave();

  return (
    <OnboardingWizard
      hideChrome
      stepKey="services"
      title={isEditMode ? "Services" : "Services & categories"}
      subtitle={isEditMode
        ? "Update what you offer and who you offer it to."
        : "Choose what you offer using the same options visitors can filter by."}
      onBack={() => goToPrevStep("services")}
      onContinue={() => goToNextStep("services")}
      continueDisabled={!canContinue}
      showSave={showSave}
      onSave={onSave}
      saveDisabled={saveDisabled}
      saveLabel={saveLabel}
      contentClassName="onboarding-wizard__content--services"
    >
      {saveError ? (
        <p className="onboarding-error-banner" role="alert">
          {saveError}
        </p>
      ) : null}
      <div className="onboarding-field">
        <span className="onboarding-field__label">Service for (required)</span>
        <div className="onboarding-chip-grid">
          {SERVICE_FOR_OPTIONS.map((option) => (
            <AppChip
              key={option}
              label={option}
              selected={draft.serviceFor.includes(option)}
              onClick={() => updateDraft({
                serviceFor: toggleListItem(draft.serviceFor, option),
              })}
            />
          ))}
        </div>
      </div>

      <div className="onboarding-field">
        <span className="onboarding-field__label">Services</span>
        <ServiceFilterAccordion
          sections={SERVICE_SECTIONS}
          selected={draft.services}
          onToggle={(service) => updateDraft({
            services: toggleListItem(draft.services, service),
          })}
          expandedSections={expandedSections}
          onToggleSection={(sectionId) => setExpandedSections((prev) => {
            const isOpen = Boolean(prev[sectionId]);
            if (isOpen) return {};
            return { [sectionId]: true };
          })}
        />
      </div>
    </OnboardingWizard>
  );
}
